import { styled } from '@mui/material/styles';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';

export const RoomConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: -2.5,
      left: 'calc(-50% + 10px)',
      right: 'calc(50% + 10px)',
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        border: 'solid #56CCF2',
        borderTopWidth: 5,
      },
      [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: -3.5,
        left: 'calc(-50% + 9px)',
        right: 'calc(50% + 9px)',
  
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        border: 'solid #56CCF2',
        borderTopWidth: 5,
      },
      [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: -3.5,
        left: 'calc(-50% + 9px)',
        right: 'calc(50% + 9px)',
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : 'rgba(67, 91, 110, 0.6)',
      borderTopWidth:5,
      borderRadius: 1,
    },
  }));

  export const RoomConnectorFreeRoamMode = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: -2,
      left: 'calc(-50% + 10px)',
      right: 'calc(50% + 10px)',
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: theme.palette.grey[800],
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: theme.palette.grey[800],
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : 'rgba(67, 91, 110, 0.6)',
      borderTopWidth: 4,
      borderRadius: 4,
    },
  }));
  
  export const RoomStepIconRoot = styled('div')<{ ownerState: { active?: boolean } }>(
    ({ theme, ownerState }) => ({
      color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : 'rgba(67, 91, 110, 0.6)',
      display: 'flex',
      height: 0,
      alignItems: 'center',
      ...(ownerState.active && {
        color: '#56CCF2',
      }),
      '& .RoomStepIcon-completedIcon': {
        color: '#56CCF2',
        width: 10,
        height: 10,
        borderRadius: '50%',
        border: '5px solid',
        backgroundColor: 'currentColor',
      },
      '& .RoomStepIcon-circle': {
        width: 10,
        height: 10,
        borderRadius: '50%',
        border: '5px solid currentColor',
        backgroundColor: 'white',
      },
    }),
  );